import React from "react"
import { TagsList } from './components/TagsList'
import widgetService from 'live/services/widgets'
import { reducer } from './reducer'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'


export default widgetService.register({
    type: 'tagsList',
    get name() {
        return 'Tags List'
    },
    get description() {
        return ''
    },
    config: {},
    //@ts-ignore
    // ui: { configForm: Config },
    policies: { defaultReducer: '', layers: 1 },
    impl: reactWidgetWrapper<ChartState, ChartMessage>(function (props) {
        
        const { state, widget, height } = props
        const {events = []} = state || {}

        if (events.length < 1) return <div> loading events... </div>

        return <TagsList batch={events} widget={widget} height={height} />
    }, reducer)
})
